<template>
  <b-container>
    <b-row class="py-3">
      <b-col md="9" sm="9" xs="12">
        <div class="question">
          <template v-if="questionList[questionIndex].typeEnum === 'single'">
            <QuestionSingle
              :key="questionList[questionIndex].id"
              :id="`item-${questionList[questionIndex].number}`"
              :data-id="questionList[questionIndex].id"
              :data-type="`${questionList[questionIndex].typeEnum}-${questionList[questionIndex].type}`"
              :parent="null"
              :question="questionList[questionIndex]"
              v-on:selectAnswer="updateAnswer"
              :editable="questionList[questionIndex].response ? false : true"
              :answer="null"
              :response="questionList[questionIndex].response"
              :isAudioPlayable="isAudioPlayable"
              :isExplain="isExplain"
            />
          </template>
          <template v-else>
            <QuestionGroup
              :key="questionList[questionIndex].id"
              :question="questionList[questionIndex]"
              v-on:selectAnswer="updateAnswer"
              :editable="questionList[questionIndex].response ? false : true"
              :response="questionList[questionIndex].response"
              :isAudioPlayable="isAudioPlayable"
              :isExplain="isExplain"
            />
          </template>
        </div>

        <b-row align-v="center" class="text-center mt-3" v-if="questionList">
          <b-col>
            <template>
              <b-button
                @click="prevQuestion"
                class="subject__part__btn btn-block"
                :disabled="!isPrev"
              >
                &larr; Câu trước
              </b-button>
            </template>
          </b-col>
          <!-- <b-col>
            <b-button
              block
              variant="light"
              size="sm"
              @click="checkResponse"
            >
              <img src="@/assets/images/ic_sai.png" alt="" height="30">
              <span>Kiểm tra</span>
            </b-button>
          </b-col>
          <b-col>
            <b-button
              block
              variant="light"
              size="sm"
              @click="isNote = true"
            >
              <img src="@/assets/images/ic_ghichu.png" alt="" height="30">
              <span>Note</span>
            </b-button>
          </b-col> -->
          <b-col>
            <template>
              <b-button
                @click="nextQuestion"
                class="subject__part__btn btn-block"
                :disabled="!isNext"
              >
                Câu sau &rarr;
              </b-button>
            </template>
          </b-col>
        </b-row>
      </b-col>
      <b-col md="3" sm="3" xs="12">
        <div class="question__info text-center">
          <h6>Thời gian làm bài</h6>
          <span>{{ convertSecondsToTime(currentTime) }}</span>

          <div class="mb-3"></div>

          <h6>Số câu làm đúng</h6>
          <span>{{ questionCorrected }}/{{ questionList.length }}</span>
        </div>
        <b-button
          block
          variant="light"
          size="sm"
          class="mt-3"
          @click="checkResponse"
        >
          <img src="@/assets/images/ic_sai.png" alt="">
          <span>Kiểm tra đáp án</span>
        </b-button>

        <b-button
          block
          variant="light"
          size="sm"
          class="mt-3"
          disabled
        >
          <img src="@/assets/images/ic_luu.png" alt="">
          <span>Lưu câu hỏi</span>
        </b-button>

        <b-button
          block
          variant="light"
          size="sm"
          class="mt-3"
          disabled
        >
          <img src="@/assets/images/ic_ghichu.png" alt="">
          <span>Note</span>
        </b-button>
      </b-col>
    </b-row>
    <b-modal v-model="isNote" title="Note câu hỏi" @ok="noteSubmit">
      <form ref="form" @submit.stop.prevent="noteSubmit">
        <b-form-group
          label="Note"
          label-for="note-input"
          invalid-feedback="Note is required"
        >
          <b-form-textarea
            id="note-input"
            v-model="note"
            required
          ></b-form-textarea>
        </b-form-group>
      </form>
    </b-modal>
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { STORE_KEY } from "../_store/constants";
import { APP_CONFIG } from "@/utils/constants";
import moment from "moment";

import QuestionSingle from "./QuestionSingle";
import QuestionGroup from "./QuestionGroup";

export default {
  name: "ClassPartDetail",
  components: {
    QuestionSingle,
    QuestionGroup
  },
  data() {
    return {
      partId: this.$route.params.id,
      slug: this.$route.params.slug,
      cdnUrl: APP_CONFIG.cdnUrl,
      action: '',
      isTimer: null,
      currentTime: 0,
      dataAnswer: [],
      response: null,
      isNote: false,
      note: null,
      isAudioPlayable: true,
      isExplain: false
    };
  },
  metaInfo() {
    return {
      title: "Lớp ôn tập"
    };
  },
  computed: {
    ...mapGetters({
      question: `${STORE_KEY}/question`,
      questionCorrected: `${STORE_KEY}/questionCorrected`,
      questionIndex: `${STORE_KEY}/questionIndex`,
      questionId: `${STORE_KEY}/questionId`,
      questionList: `${STORE_KEY}/questionList`,
      isNext: `${STORE_KEY}/isNext`,
      isPrev: `${STORE_KEY}/isPrev`,
    })
  },
  beforeMount() {
    this.getPartQuestion({
      partId: this.partId,
      questionId: this.questionId,
      action: this.action
    });
  },
  mounted() {
    this.isTimer = setInterval(function() {
      this.currentTime++;
    }.bind(this), 1000);
  },
  methods: {
    ...mapActions(`${STORE_KEY}`, ["clearQuestion", "clearQuestionList", "getPartQuestion", "setQuestionIndex", "postQuestionResponse"]),
    convertSecondsToTime(sec) {
      var hrs = Math.floor(sec / 3600)
      var min = Math.floor((sec - (hrs * 3600)) / 60)
      var seconds = sec - (hrs * 3600) - (min * 60)
      seconds = Math.round(seconds * 100) / 100
      
      var result = (hrs < 10 ? "0" + hrs : hrs)
      result += ":" + (min < 10 ? "0" + min : min)
      result += ":" + (seconds < 10 ? "0" + seconds : seconds)

      return result
    },
    parseUTCDate(ts) {
      return moment.unix(ts);
    },
    updateAnswer(data) {
      let isNew = true;

      this.dataAnswer.forEach(question => {
        if (question.question_id == data.question_id) {
          isNew = false;
          
          if (typeof data.answer !== 'undefined') {
            question.answer = data.answer;
          }

          if (typeof data.answer_id !== 'undefined') {
            question.answer_id = data.answer_id;
          }
        }
        
      });

      if (isNew) {
        this.dataAnswer.push(data);
      }
    },
    checkResponse() {
      this.isAudioPlayable = false;
      this.isExplain = true;
      if (!this.dataAnswer.length) {
        if (this.questionList[this.questionIndex].typeEnum == "single") {
          this.dataAnswer.push({
            question_id: this.questionList[this.questionIndex].id
          });
        } else {
          this.questionList[this.questionIndex].children.forEach((item) => {
            this.dataAnswer.push({
              question_id: item.id
            });
          });
        }
      }

      if (this.questionList[this.questionIndex].typeEnum == "single") {
        this.questionList[this.questionIndex].response = this.dataAnswer[0];
      } else {
        this.questionList[this.questionIndex].response = this.dataAnswer;
      }

      this.postQuestion();
    },
    noteSubmit() {
      //
    },
    postQuestion() {
      this.postQuestionResponse({
        part_id: this.partId,
        question_id: this.questionList[this.questionIndex].id,
        answer: this.dataAnswer,
        is_save: 0
      });
      this.dataAnswer = [];
    },
    getQuestion() {
      this.postQuestion();
      this.getPartQuestion({
        partId: this.partId,
        questionId: this.questionId,
        action: this.action
      });
      this.isExplain = false;
    },
    nextQuestion() {
      if (this.questionIndex + 1 < this.questionList.length) {
        if (!this.questionList[this.questionIndex].response) {
          this.postQuestion();
        }
        this.setQuestionIndex(this.questionIndex + 1);
      } else {
        this.action = "next";
        this.getQuestion();
      }
    },
    prevQuestion() {
      if (this.questionIndex > 0) {
        if (!this.questionList[this.questionIndex].response) {
          this.postQuestion();
        }
        this.setQuestionIndex(this.questionIndex - 1);
      } else {
        this.postQuestion();
        this.action = "prev";
        this.getQuestion();
      }
    }
  },
  beforeDestroy() {
    this.clearQuestion();
    this.clearQuestionList();
    clearInterval(this.isTimer);
  }
};
</script>
